import { render, staticRenderFns } from "./LevelSelect.vue?vue&type=template&id=71d12aee&scoped=true&"
import script from "./LevelSelect.vue?vue&type=script&lang=js&"
export * from "./LevelSelect.vue?vue&type=script&lang=js&"
import style0 from "./LevelSelect.vue?vue&type=style&index=0&id=71d12aee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d12aee",
  null
  
)

export default component.exports